import React from "react";

import { Container } from "./styles";

function RadioButton(props) {
  return <Container {...props} />;
}

export default RadioButton;
